export default "__VITE_PUBLIC_ASSET__24cea4bc__"